import { Icon, IconColorType, IconNameType, IconSizeType } from "@/lib/main";
import { CSSProperties } from "react";
import BadgeCounter from "./BadgeCounter";

type Props = {
  count: number;
  iconColor: IconColorType;
  iconName: IconNameType;
  size?: IconSizeType;
};

export default function IconCounter({
  count,
  iconColor,
  iconName,
  size,
}: Props) {
  const iconContainerStyle: CSSProperties = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={iconContainerStyle}>
      <Icon color={iconColor} name={iconName} size={size} />
      {count ? <BadgeCounter count={count} size={size} /> : null}
    </div>
  );
}
